import { Effect, Layer } from "effect";
import { splitPanePointerRatio } from "../../split-pane-model.ts";
import { panePointerFailure } from "./pane-pointer-model.ts";
import { PanePointerIo } from "./pane-pointer-service.ts";

export const PanePointerIoLive = Layer.succeed(PanePointerIo, {
  capture: (target, pointerId, prevent) => Effect.try({ try: () => { prevent();target.setPointerCapture(pointerId); }, catch: panePointerFailure }),
  measure: (container, input) => Effect.try({ try: () => {
    const rect = container.getBoundingClientRect();
    return splitPanePointerRatio({ clientPosition: input.client, containerStart: input.vertical ? rect.left : rect.top,
      containerSize: input.vertical ? rect.width : rect.height, bounds: input });
  }, catch: panePointerFailure }),
  release: (target, pointerId) => Effect.try({ try: () => { if (target.hasPointerCapture(pointerId)) target.releasePointerCapture(pointerId); }, catch: panePointerFailure })
});
